import { createSlice } from '@reduxjs/toolkit';
import store from 'store2';

const appInitialState = {
  hostList: [],
  cameraList: [],
  streamList: [],
  adaptorType: '',
  adaptorVersion: '',
  publicIp: '',
  showDebugOptions: store('showDebugOptions'),

  recordedTestFailed: {status: false, reason: ""}
};

const appSlice = createSlice({
  name: 'hosts',
  initialState: appInitialState,
  reducers: {
    setPublicIp(state, action) {
      state.publicIp = action.payload;
    },
    setRecordedTestFailed(state, action) {
      state.recordedTestFailed = action.payload;
    },
    toggleDebugOptions(state, action) {
      state.showDebugOptions = action.payload;
    },
    addVstHost(state, action) {
      const arr = store('hosts');
      console.log('arr: ', arr);
      if (arr == null) {
        store.set('hosts', [action.payload]);
        state.hostList.push(action.payload);
      } else if (!arr.includes(action.payload)) {
        console.log('arr: ', action.payload);
        state.hostList.push(action.payload);
        arr.push(action.payload);
        store.set('hosts', arr);
      } else {
        state.hostList = store('hosts');
      }
    },
    removeVstHost(state, action) {
      const index = state.hostList.indexOf(action.payload);
      if (index !== -1) {
        state.hostList.splice(index, 1);
        const arr = store('hosts');
        const arrIndex = arr.indexOf(action.payload);
        if (arrIndex !== -1) {
          arr.splice(index, 1);
          store.set('hosts', arr);
        }
        state.cameraList = state.cameraList.filter((obj) => obj.host !== action.payload);
        state.streamList = state.streamList.filter((obj) => obj.host !== action.payload);
      }
    },
    addDevice(state, action) {
      if (action.payload.length > 0) {
        const camHost = action.payload[0].host;
        state.cameraList = state.cameraList.filter((obj) => obj.host !== camHost);
        // removed all old cams of host trying to add new cameras and add new ones
        for (let i = 0; i < action.payload.length; i += 1) {
          state.cameraList.push(action.payload[i]);
        }
      }
    },
    removeDevice(state, action) {
      console.log('remove device: ', action.payload);
      state.cameraList = state.cameraList.filter(
        (obj) => !obj.host === action.payload.host && !obj.id === action.payload.id
      );
    },
    addStream(state, action) {
      if (action.payload.length > 0) {
        const camHost = action.payload[0].host;
        state.streamList = state.streamList.filter((obj) => obj.host !== camHost);
        // removed all old cams of host trying to add new cameras and add new ones
        for (let i = 0; i < action.payload.length; i += 1) {
          state.streamList.push(action.payload[i]);
        }
      }
    },
    removeStream(state, action) {
      state.streamList = state.streamList.filter((obj) => !obj.host === action.payload);
    },
    setAdaptorType(state, action) {
      state.adaptorType = action.payload;
    },
    setAdaptorVersion(state, action) {
      state.adaptorVersion = action.payload;
    },
  },
});

export const appSliceActions = appSlice.actions;
export default appSlice;
